import React from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { paginationDropdownOptions } from 'constants/dropdownOptions';
import ResizableDataTable from 'components/ResizableDataTable/ResizableDataTable';

const PrimeReactDataTable = (props) => {
  const {
    tableValues,
    columnFields,
    isPaginated = true,
    paginationData = {},
    onNextPageClick = () => {},
    onPageChange = () => {},
    onPrevPageClick = () => {},
    ...restProps
  } = props || {};

  const { pageLimit: rowsCount, apiTransitionToken: transitionToken, apiNextToken: nextToken, isForward } = paginationData || {};

  const paginatorTemplate = {
    layout: 'RowsPerPageDropdown PrevPageLink NextPageLink',
    RowsPerPageDropdown: (options) => {
      return (
        <>
          <span className="mx-1" style={{ color: 'var(--black-500)', userSelect: 'none' }}>
            Item Per Page
          </span>
          <Dropdown value={options.value} options={paginationDropdownOptions} onChange={onPageChange} />
        </>
      );
    },
    NextPageLink: ({ iconClassName }) => {
      return (
        <Button
          onClick={onNextPageClick}
          disabled={nextToken === null && isForward}
          className={'p-paginator-next p-paginator-element p-link'}
          icon={iconClassName}
        />
      );
    },
    PrevPageLink: ({ iconClassName }) => {
      return (
        <Button
          onClick={onPrevPageClick}
          disabled={transitionToken === null || (transitionToken && nextToken === null && !isForward)}
          className={'p-paginator-next p-paginator-element p-link'}
          icon={iconClassName}
        />
      );
    },
  };

  return (
    <div className="datatable-responsive">
      <ResizableDataTable
        value={tableValues}
        paginator={isPaginated}
        paginatorTemplate={paginatorTemplate}
        rows={rowsCount}
        className="p-datatable-responsive"
        columns={columnFields}
        {...restProps}
      />
    </div>
  );
};

export default PrimeReactDataTable;
